/* eslint-disable angular/constant-name */

angular.module("digiexam.services").constant("PermissionShareEnum",
	Object.freeze({
		GRADING: "PSGrading",
		LIBRARY_EXAM: "PSLibraryExam",
		LIBRARY_GRADINGMATRIX: "PSLibraryGradingMatrix",
		LIVE_EXAM: "PSLiveExam",
	})
);
